module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_8003.60bb124d.png";